<div class="row" style="margin: 0px auto;">
  <div class="col text-center">
    <br><br><br>
    <!-- <a href="https://www.lexgom.com.co" target="_blank"> <img src="https://www.lexgom.com.co/assets/GENERAL/powerBy.png" height="30"></a> -->
    <br><br><br>
  </div>
 </div>
